<template>
  <div class="col-12 row q-col-gutter-x-sm items-center">
    <model-form-select
      :field="ticketTypesField"
      class="col-8"
      :label="`${(conditional.conditionsRequirements[excludeTicketTypesField] ? 'Exclude' : 'Include')} Ticket Types`"
      :options="ticketTypes.data"
      option-label="name"
      option-value="id"
      map-options
      emit-value
      multiple
      use-chips
      clearable
      :rules="[
        val => !!val || 'Field is required',
        val => val.length > 0 || 'Must select at least one ticket type'
      ]"
    />
    <model-form-toggle
      :field="`conditionsRequirements.${excludeTicketTypesField}`"
      class="col-4 q-mb-md"
      label="Exclude"
      value-type="Boolean"
    />
  </div>
</template>

<script>
import { CONDITIONS_REQUIREMENTS } from 'src/models/booking-fee-type/BookingFeeType'

export default {
  name: 'TicketTypesConditionForm',
  configuration: ['ticketTypes'],
  props: {
    conditional: {
      type: Object,
      required: true
    },
    ticketTypesField: {
      type: String,
      default: CONDITIONS_REQUIREMENTS.TICKET_TYPES
    },
    excludeTicketTypesField: {
      type: String,
      default: CONDITIONS_REQUIREMENTS.EXCLUDE_TICKET_TYPES
    }
  }
}

</script>
